import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_STOCK_ORDER_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_STOCK_ORDER_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_STOCK_ORDER_DETAIL_API_ID,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/stock-orders/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
